import React from 'react';
// import qrcode from '../OLLV Donate-QR_Code.jpg';
import masstimesccc from '../correctsizeccpmass.jpg'
// import Navbar from './components/Navbarofapp';

function Masstime() {
 

    // redirect to home after 18 secs
    setTimeout(() => {
    //   history.push('/')
    window.location.href = "/";
    }, 50000) //50 secs


    // const gotoHome = () => {
    //     window.location.href = "/";
    // }
  

  return (
    // <Link to="/">
      <div className="s-pagewrap">
    
      

      <div>
      <img style= {{ display:'block', margin: '0 auto',height:1920 , width:1080}}  src={masstimesccc} alt="CCC Mass Times" class="src" />
      </div>
       

          {/***  <div className="kiosk-footer">
           <h2>For Kiosk hardware or software problems, call IT Department at (714) 282-3019</h2>
        </div>*/}
  
      </div>
    //   </Link>
  )
}

export default Masstime